import React from "react";
import LegalPageLayout from "./LegalPageLayout";

export default function CookieSettingsPage() {
  return (
    <LegalPageLayout title="Cookie Settings">
      <section>
        <p>This website uses cookies and similar tracking technologies to ensure proper functionality, enhance user experience, analyse website traffic, and support our marketing efforts.</p>
        <p className="mt-3">Essential cookies are required for the operation of the website and cannot be disabled. Non-essential cookies, including analytics and performance cookies, help us understand how visitors interact with the website and allow us to improve our services.</p>
        <p className="mt-3">You may manage or withdraw your consent for non-essential cookies at any time through your browser settings. Please note that disabling certain cookies may impact the functionality and performance of the website.</p>
        <p className="mt-3">By continuing to use this website, you consent to the use of cookies in accordance with our Privacy Policy.</p>
      </section>
    </LegalPageLayout>
  );
}
